// hooks/useClock.js
import { useContext } from 'react';
import { ClockContext } from '../context/ClockContext'; // Ajusta la ruta según la ubicación del archivo

export const useClock = () => useContext(ClockContext);
